export default "__VITE_ASSET__f86a1aa0__"